/**
 * ConnectivityBanner — Shows "offline — retreat continues" when device goes offline.
 *
 * E2E-CONNECTIVITY-UI-P1-001: Offline indicator for active retreats.
 * INV-018: Named event handler functions for proper cleanup.
 * Design: low-contrast ink (not warning red) — offline is normal for an offline-first PWA.
 */
import { useEffect, useState } from "react";
import { TEST_IDS } from "../testing/testIds";
import styles from "./ConnectivityBanner.module.css";

export function ConnectivityBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const onOnline = () => setOffline(false);
    const onOffline = () => setOffline(true);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      className={styles.banner}
      data-testid={TEST_IDS.CONNECTIVITY_BANNER}
    >
      offline — retreat continues
    </div>
  );
}
